import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { bindActionCreators } from 'redux';
import { setDataLayer } from 'shared/actions/globals';
import { injectLocationIntoHref } from 'shared/helpers/locale';
import { isValidLeasingLocationRoute } from 'shared/helpers/routes';
import Link from 'shared/components/Link/Link';
import LOCATION_TYPES from 'shared/constants/locationTypes';
import COUNTRIES from 'shared/constants/json/countries.json';
import { EVENTS } from 'shared/constants/gtmEvents';
import { withTranslate } from 'shared/hocs/withTranslate';
import s from './NavigationLink.css';

class NavigationLink extends React.Component {
  static propTypes = {
    link: PropTypes.shape({
      route: PropTypes.string,
      title: PropTypes.string,
      count: PropTypes.string,
      injectLocations: PropTypes.arrayOf(PropTypes.oneOf(Object.values(LOCATION_TYPES))),
    }).isRequired,
    location: PropTypes.shape(),
    locationType: PropTypes.oneOf(Object.values(LOCATION_TYPES)).isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    //
    activeClassName: PropTypes.string,
    currentRoute: PropTypes.string,
    including: PropTypes.bool,
    setDataLayer: PropTypes.func.isRequired,
    eventPrefix: PropTypes.string,
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    currentRoute: null,
    location: null,
    shouldCalculateActiveState: true,
    including: false,
    className: '',
    activeClassName: '',
    onClick: () => {},
    eventPrefix: '',
  };

  handleClick = e => {
    const { link, eventPrefix, onClick } = this.props;
    onClick(e);
    if (!eventPrefix) return;

    const route = link.slug || link.route;
    const pattern = new RegExp('[/]{2,}', 'g');
    const slug = `${eventPrefix}${route}`.replace(pattern, '/');
    const event = EVENTS.NAVIGATION_LINK[slug];
    if (event) this.props.setDataLayer(event);
  };

  render() {
    const {
      location,
      including,
      locationType,
      currentRoute,
      link,
      className,
      activeClassName,
      t,
    } = this.props;
    const { route, injectLocations, title, count = '' } = link;

    let isActive = false;
    if (currentRoute) {
      isActive = including
        ? currentRoute.includes(`${link.slug || link.route}/`.replace(/\/\//g, '/'))
        : currentRoute === `${link.slug || link.route}/`.replace(/\/\//g, '/');
    }

    return isActive
      ? <span className={cx(className, activeClassName)}>
          {t(title)}
          {count &&
            <span className={s.count}>
              {' '}{count}
            </span>}
        </span>
      : <Link
          onClick={this.handleClick}
          to={
            location &&
            injectLocations &&
            injectLocations.includes(locationType) &&
            isValidLeasingLocationRoute(route, location.slug)
              ? injectLocationIntoHref(route, location.slug)
              : route
          }
          className={className}
        >
          {t(title)}
          {count &&
            <span className={s.count}>
              {' '}{count}
            </span>}
        </Link>;
  }
}

const mapStateToProps = ({ globals }) => ({
  location: globals.location,
  locationType: COUNTRIES.find(city => city.slug === (globals.location && globals.location.slug))
    ? LOCATION_TYPES.COUNTRY
    : LOCATION_TYPES.CITY,
});

const mapDispatchToProps = dispatch => ({
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslate(NavigationLink)),
);



// WEBPACK FOOTER //
// ./src/shared/components/NavigationLink/NavigationLink.js